import React, {FunctionComponent} from 'react';
import {IActivityXpedition} from '../../redux/activities/interfaces';
import {FormattedMessage} from 'react-intl';

import './styles.scss';
import {
  activitiesAsyncActions,
  removeActivityDialogue,
  removeSessionDialogue,
  sessionsAsyncActions
} from '../../redux/pageAsyncActions';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';

interface IActivityCardProps {
  activity: IActivityXpedition;
}

export const ActivityCard: FunctionComponent<IActivityCardProps> = ({
  activity
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showStart = !activity.dialogId;
  const showContinue = !showStart;
  const isCompleted = activity.percentage === 100;

  function handleStartActivity() {
    navigate(`/activity/${activity.xpeditionId}`);
  }

  async function handleRemoveActivity() {
    dispatch(activitiesAsyncActions[removeActivityDialogue](activity.dialogId));
  }

  const getCardClass = () => {
    if (activity.percentage === 100) {
      return 'completed';
    }
    if (activity.dialogId) {
      return 'in-progress';
    }

    return '';
  };

  return (
    <article className={`activity-card ${getCardClass()}`}>
      <div
        style={{
          height: 180,
          backgroundImage: `url(${activity.imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      <div className="activity-card__body">
        <div className="activity-card__title">{activity.theme}</div>
        <div className="activity-card__desc">{activity.description}</div>

        <div className="activity-card__actions">
          <div style={{width: '100%'}}>
            <div className="progress-bar">
              <div className={`progress-fill ${isCompleted ? 'completed' : ''}`} style={{width: `${activity.percentage}%`}} />
            </div>
          </div>
          <div style={{display: 'flex', gap: 8, width: '100%'}}>
            {showStart && <button className="btn primary"
              onClick={handleStartActivity}>
              <FormattedMessage
                id={'gritx.activities.open'}
                defaultMessage="Open"
              />
            </button>}
            {showContinue && <button className="btn primary"
              onClick={handleStartActivity}>
              <FormattedMessage
                id={'gritx.activities.open'}
                defaultMessage="Open"
              />
            </button>}
            {activity.dialogId && <button className="btn secondary"
              onClick={handleRemoveActivity}>
              <FormattedMessage
                id={'gritx.activities.startOver'}
                defaultMessage="Start Over"
              />
            </button>}
          </div>
        </div>
      </div>
    </article>
  );
};

